<!-- Flex container with space-between -->
<div class="basin-display-flex basin-align-center basin-justify-content-space-between basin-width-100 basin-mb-4">

  <!-- LEFT: Search Box -->
  <div class="basin-display-flex basin-align-center">
    <basin-searchbox class="searchbox basin-mr-6" #searchInput (searchStringChange)="searchStringChange($event)">
    </basin-searchbox>
  </div>

  <!-- CENTER + RIGHT Group -->

  <!-- CENTER: Bulk Action -->

  <!-- RIGHT: Important Info -->


  <div class="basin-display-flex basin-align-content-center basin-justify-content-end">
    <button pButton class="p-button-text basin-mr-1 basin-ml-1" pTooltip="Please click here to get latest simulation status"
     (click)="refreshGrid()">
      <span class="material-icons"><span class="material-icons">refresh</span></span> Refresh
    </button>

    <span class="divider basin-ml-3 basin-mr-3"></span> 
    <button pButton class="p-button-text basin-mr-1 basin-ml-1" (click)="openExportByTypeModal()"
      [disabled]="!anyRowSelected">
      <span class="material-icons"><span class="material-icons">cloud_download</span></span> Export
    </button>

    <button pButton class="p-button-text basin-mr-1 basin-ml-1" (click)="handleDeleteCommand()"
      [disabled]="!anyRowSelected">
      <span class="material-icons"><span class="material-icons">delete_outline</span></span> Delete
    </button>

    <span class="divider basin-ml-3 basin-mr-3"></span>

    <button pButton class="p-button-text important-info-button" icon="symbol-info" label="Information"
      (click)="showDialog()">
    </button>
  </div>

</div>

<div class="basin-width-100" *ngIf="!cardMode">
  <ng-container *ngTemplateOutlet="table"></ng-container>
</div>

<p-card *ngIf="cardMode">
  <ng-container *ngTemplateOutlet="table"></ng-container>
</p-card>

<ng-template #table>
  <p *ngIf="anyRowSelected" class="selected-label-text basin-mb-4">
    You have selected
    <span class="highlight-selected-label-text">{{ selectedSimulations }}</span>
    simulations.
  </p>
  <p-table styleClass="basin-table-height p-datatable-sm" withUnsort responsiveLayout="scroll"
    [frozenColumns]="frozenColumns" [scrollable]="true" [paginator]="true" (onPage)="onPageChange($event)"
    (onFilter)="onFilterChange($event)" [rows]="rows"
    paginatorStyleClass="basin-display-flex basin-align-items-center basin-justify-content-end"
    [rowsPerPageOptions]="paginatorDropdownOptions" currentPageReportTemplate="{first} - {last} of {totalRecords}"
    [showCurrentPageReport]="true" [globalFilterFields]="[
    'simulationName',
      'studyAreaName',
      'status',
      'statusMessage',
      'flatTags',
      'shared'
    ]" [value]="(simulationItems) || []">
    <ng-template pTemplate="header">
      <tr>
        <th id="allSelectedcheckbox" style="width: 2rem;">
          <p-checkbox [binary]="true" [(ngModel)]="allSelected" (onChange)="toggleAllSelections()"></p-checkbox>
        </th>
        <th id="simulationName" pSortableColumn="simulationName">
          <div class="p-d-flex p-ai-center">
            Simulation Name
            <p-sortIcon field="simulationName"></p-sortIcon>
            <p-columnFilter type="text" field="simulationName" display="menu" (click)="$event.stopPropagation()"
              (keydown)="onFilterKeyDown($event)" (keyup)="onFilterKeyUp($event)"
              (keypress)="onFilterKeyPress($event)"></p-columnFilter>
          </div>
        </th>

        <th id="studyAreaName" pSortableColumn="studyAreaName">
          <div class="p-d-flex p-ai-center">
            Study Area Name
            <p-sortIcon field="studyAreaName"></p-sortIcon>
            <p-columnFilter type="text" field="studyAreaName" display="menu" (click)="$event.stopPropagation()"
              (keydown)="onFilterKeyDown($event)" (keyup)="onFilterKeyUp($event)"
              (keypress)="onFilterKeyPress($event)"></p-columnFilter>
          </div>
        </th>
        <th id="areaMeasurement" pSortableColumn="areaMeasurement">
          <div class="p-d-flex p-ai-center">
            Total Area
            <p-sortIcon field="areaMeasurement"></p-sortIcon>
            <p-columnFilter type="numeric" field="areaMeasurement" display="menu" (click)="$event.stopPropagation()"
              (keydown)="onFilterKeyDown($event)" (keyup)="onFilterKeyUp($event)"
              (keypress)="onFilterKeyPress($event)"></p-columnFilter>
          </div>
        </th>
        <th id="userName" pSortableColumn="userName">
          <div class="p-d-flex p-ai-center fixed-width-200">
            Initiated By
            <p-sortIcon field="userName"></p-sortIcon>
            <p-columnFilter type="text" field="userName" display="menu" (click)="$event.stopPropagation()"
              (keydown.enter)="$event.stopPropagation()" (keydown)="onFilterKeyDown($event)"
              (keyup)="onFilterKeyUp($event)" (keypress)="onFilterKeyPress($event)"></p-columnFilter>
          </div>
        </th>
        <th id="created" pSortableColumn="created">
          <div class="p-d-flex p-ai-center">
            Simulation Start
            <p-sortIcon field="created"></p-sortIcon>
            <p-columnFilter type="date" field="created" display="menu" (click)="$event.stopPropagation()"
              (keydown)="onFilterKeyDown($event)" (keyup)="onFilterKeyUp($event)"
              (keypress)="onFilterKeyPress($event)"></p-columnFilter>
          </div>
        </th>
        <th id="statusUpdated" pSortableColumn="statusUpdated">
          <div class="p-d-flex p-ai-center">
            Simulation End
            <p-sortIcon field="statusUpdated"></p-sortIcon>
            <p-columnFilter type="date" field="statusUpdated" display="menu" (click)="$event.stopPropagation()"
              (keydown)="onFilterKeyDown($event)" (keyup)="onFilterKeyUp($event)"
              (keypress)="onFilterKeyPress($event)"></p-columnFilter>
          </div>
        </th>
        <th id="statusMessage" pSortableColumn="statusMessage">
          <div class="p-d-flex p-ai-center">
            Status
            <p-sortIcon field="statusMessage"></p-sortIcon>
            <p-columnFilter type="text" field="statusMessage" display="menu" (click)="$event.stopPropagation()"
              (keydown)="onFilterKeyDown($event)" (keyup)="onFilterKeyUp($event)"
              (keypress)="onFilterKeyPress($event)"></p-columnFilter>
          </div>
        </th>
        <th id="expiration" pSortableColumn="expiration">
          <div class="p-d-flex p-ai-center">
            Expiration
            <p-sortIcon field="expiration"></p-sortIcon>
            <p-columnFilter type="date" field="expiration" display="menu" (click)="$event.stopPropagation()"
              (keydown)="onFilterKeyDown($event)" (keyup)="onFilterKeyUp($event)"
              (keypress)="onFilterKeyPress($event)"></p-columnFilter>
          </div>
        </th>
        <th id="flatTags" pSortableColumn="flatTags">
          <div class="p-d-flex p-ai-center">
            Tags
            <p-sortIcon field="flatTags"></p-sortIcon>
            <p-columnFilter field="flatTags" display="menu" [showMenu]="true" [showOperator]="false"
              [showMatchModes]="false" [showApplyButton]="false" [showClearButton]="false" [showAddButton]="false"
              (click)="$event.stopPropagation()" (keydown)="handleKeyDown($event)">
              <ng-template pTemplate="filter" let-value let-filter="filterTagCallback">
                <div *ngFor="let tag of tagList">
                  <p-checkbox [value]="tag.name" [(ngModel)]="tagFilterValues" (onChange)="onTagFilterChange()"
                    inputId="{{ tag.name }}" class="basin-mb-1 basin-pr-1"></p-checkbox>
                  <label for="{{ tag.name }}">{{ tag.name }}</label>
                </div>
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        <th id="shared" pSortableColumn="shared">
          <div class="p-d-flex p-ai-center">
            DFP Specialist Access
            <p-sortIcon field="shared"></p-sortIcon>
            <p-columnFilter field="shared" display="menu" [showMenu]="true" [showOperator]="false"
              [showMatchModes]="false" [showApplyButton]="false" [showClearButton]="false" [showAddButton]="false"
              (click)="$event.stopPropagation()">
              <ng-template pTemplate="filter" let-value let-filter="filterSharedCallback">
                <div *ngFor="let shared of dfpAccessList">
                  <p-checkbox [value]="shared.name" [(ngModel)]="dfpAccessFilterValues"
                    (onChange)="onDFPAccessFilterChange()" inputId="{{ shared.name }}"
                    class="basin-mb-1 basin-pr-1"></p-checkbox>
                  <label for="{{ shared.name }}">{{ shared.name }}</label>
                </div>
              </ng-template>
            </p-columnFilter>
          </div>
        </th>
        <th id="actions" alignFrozen="right" pFrozenColumn [frozen]="true" class="basin-px-2"></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-tableRow>
      <tr>
        <!-- Check box to download simulation -->
        <td> <p-checkbox [binary]="true" [disabled]="tableRow.statusMessage !== statusMessage.Completed"
            [(ngModel)]=tableRow.selected (onChange)="onRowCheckboxChange()"></p-checkbox> </td>
        <!-- Simulation Name -->
        <td>{{ tableRow.simulationName }}</td>

        <!-- Study Area Name -->
        <td>{{ tableRow.studyAreaName }}</td>

        <!-- Total Area -->
        <td>{{ tableRow.totalArea }}</td>

        <!-- User Name / Initiated By -->
        <td>{{ tableRow.userName }}</td>


        <!-- Simulation Start -->
        <td>{{ tableRow.created | date : "MM-dd-yyyy hh:mm a" }}</td>

        <!-- Simulation End (only show if status is "Completed") -->
        <td *ngIf="tableRow.statusMessage === statusMessage.Completed">
          {{ tableRow.statusUpdated | date : "MM-dd-yyyy hh:mm a" }}
        </td>
        <td *ngIf="tableRow.statusMessage !== statusMessage.Completed"></td>

        <!-- Status with basin-tag -->
        <td>
          <basin-tag *ngIf="tableRow.statusMessage" [value]="getStatus(tableRow.statusMessage)"
            [theme]="getStatusTheme(tableRow.statusMessage)" [icon]="getStatusIcon(tableRow.statusMessage)"></basin-tag>
        </td>

        <!-- Expiration: Show "Doesn't Expire" if retain = true, else format countdown -->
        <td>
          <div class="p-d-flex p-ai-center"
            *ngIf="tableRow.statusMessage === statusMessage.Completed || tableRow.statusMessage === statusMessage.Failed">
            <span *ngIf="tableRow.favorited">Doesn't Expire</span>
            <span *ngIf="!tableRow.favorited" class="symbol-timer outlined"></span>
            <span *ngIf="!tableRow.favorited" class="basin-pl-1">{{
              formatExpiration(tableRow.expiration)
              }}</span>
          </div>
        </td>

        <!-- Tags -->
        <td>
          <div class="p-d-flex p-ai-center">
            <ng-container *ngFor="let tag of tableRow.tags; let last = last">
              <basin-tag [value]="tag.value" [theme]="tag.theme" [icon]="tag.icon"
                [styleClass]="!last ? 'basin-mr-1' : ''"></basin-tag>
            </ng-container>
          </div>
        </td>

        <!--DFP Specialist Access-->
        <td>{{ tableRow.shared}}</td>

        <td class="sticky-col-right basin-px-2">
          <div class="basin-display-flex basin-flex-row basin-align-items-center basin-justify-content-start">
            <button pButton (click)="setTrackerMenu(tableRow); simulationActionsPopup.toggle($event)"
              icon="symbol-settings" class="p-button p-button-text basin-color-orange"></button>
          </div>

          <p-menu #simulationActionsPopup [tabindex]="undefined" [model]="trackerMenuItems" [popup]="true"
            appendTo="body">
          </p-menu>
        </td>
      </tr>
    </ng-template>
  </p-table>
</ng-template>

<p-dialog header="Important Information" [(visible)]="display" [showHeader]="true" [modal]="true"
  [dismissableMask]="true" styleClass="" draggable="false">
  <div class="basin-pb-2">
    All simulation outputs on this page are saved for up to <span
      class="basin-font-weight-bold">{{convertNumberToWords(simulationDaysRetained)}} ({{ simulationDaysRetained
      }})</span> days.
    Please take action promptly to avoid losing your work.
  </div>
  <div class="basin-pb-2">
    You can save up to <span class="basin-font-weight-bold">{{convertNumberToWords(favoritesLimit)}} ({{ favoritesLimit
      }})</span>
    simulation outputs by clicking the gear icon in the <span class="basin-font-weight-bold">Actions</span> column.
    This feature is available as long as your license remains active.
  </div>
  <div class="basin-pb-2">
    To save your results, select one or more simulations or scenarios using the checkboxes on the Simulation Results
    dashboard.
    Then click <span class="basin-font-weight-bold">Export</span> at the top and choose the file types you need.
    Your selections will download in a single ZIP folder.
  </div>
  <ng-template pTemplate="footer">
    <button pButton (click)="display = false" label="Understood" [text]="true"></button>
  </ng-template>
</p-dialog>